import Script from 'next/script'
import { getConfig } from 'src/config'

declare global {
  interface Window {
    configureWebHeartbeat?: (gnarUrl: string) => void
  }
}

export const WebHeartbeatScript = () => {
  const gnarUrl = getConfig().tracking.gnar.url
  const src = `https://static-web.${getConfig().domains.main}/web-heartbeat/latest/index.js`

  return (
    <Script
      id="web-heartbeat"
      src={src}
      strategy="beforeInteractive"
      onReady={() => {
        if (typeof window.configureWebHeartbeat === 'function') {
          window.configureWebHeartbeat(gnarUrl)
        }
      }}
    />
  )
}
